// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpMerchant';

/** 查询商户余额 GET /mch/account/balance/query */
export async function accountBalanceQuery(options?: CustomRequestOptions) {
  return request<APISdpMerchant.GatewayDataResponseAccountBalanceDto_>(
    '/mch/account/balance/query',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 查询商户余额 POST /mch/balance/query */
export async function mchBalanceQuery(
  body: APISdpMerchant.ApiBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayDataResponseAccountBalanceDto_>('/mch/balance/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询商户余额(V2){拆分待结算余额和待分账余额} POST /mch/v2/balance/query */
export async function v2BalanceQuery(
  body: APISdpMerchant.ApiBaseRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMerchant.GatewayDataResponseAccountBalanceDto_>('/mch/v2/balance/query', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
